import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface FooterProps {
  lang: string;
}

export default function Footer({ lang }: FooterProps) {
  const { t } = useTranslation();
  const homePath = `/${lang}`;

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = `${homePath}#${id}`;
    }
  };

  return (
    <footer className="w-full bg-background-100 border-t border-background-200/70">
      <div className="section-container py-12 md:py-16">
        <div className="section-inner">
          {/* Disclaimer */}
          <div className="mb-10 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200/70">
            <p className="text-sm text-foreground-600 leading-relaxed">
              {t('footer_disclaimer')}
            </p>
          </div>

          {/* Links grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mb-10">
            <div>
              <h4 className="font-heading font-semibold text-foreground-950 mb-3 text-sm">
                {t('nav_brand')}
              </h4>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Independent informational resource for AllChinaBuy buyers.
              </p>
            </div>
            <div>
              <h4 className="font-heading font-semibold text-foreground-950 mb-3 text-sm">
                Resources
              </h4>
              <ul className="space-y-2">
                <li>
                <button onClick={() => scrollToSection('guides')} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer text-left">
                    {t('nav_guides')}
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('faq')} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer text-left">
                    {t('nav_faq')}
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('categories')} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer text-left">
                    {t('nav_categories')}
                  </button>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-heading font-semibold text-foreground-950 mb-3 text-sm">
                Legal
              </h4>
              <ul className="space-y-2">
                <li>
                  <span className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    {t('footer_privacy')}
                  </span>
                </li>
                <li>
                  <span className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    {t('footer_terms')}
                  </span>
                </li>
                <li>
                  <span className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    {t('footer_policy')}
                  </span>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-heading font-semibold text-foreground-950 mb-3 text-sm">
                Main Website
              </h4>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors"
              >
                kaspreadsheet.com
                <i className="ri-external-link-line" />
              </a>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-foreground-500">
              {t('footer_copyright')}
            </p>
            <div className="flex items-center gap-4">
              <span className="text-sm text-foreground-500">{t('footer_about')}</span>
              <span className="text-sm text-foreground-500">{t('footer_contact')}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}